import { render, staticRenderFns } from "./otherIp.vue?vue&type=template&id=651cff12&scoped=true&"
import script from "./otherIp.vue?vue&type=script&lang=js&"
export * from "./otherIp.vue?vue&type=script&lang=js&"
import style0 from "./otherIp.vue?vue&type=style&index=0&id=651cff12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651cff12",
  null
  
)

export default component.exports